import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { BILLING_TYPES } from "../../types/billings";
import { CardSelector, CardSelectorOption, CardSelectorProps } from "../CardSelector";

type BillingTypeCardSelectorProps = Omit<CardSelectorProps, "options">;

export const BillingTypeCardSelector: React.FC<BillingTypeCardSelectorProps> = ({ onChange, selectedId }) => {
  const { t } = useTranslation();

  const options: CardSelectorOption[] = useMemo(
    () =>
      BILLING_TYPES.map((type) => ({
        id: type,
        title: t(`billingType.${type}`),
        description: t(`billingTypeDescription.${type}`),
      })),
    [t]
  );

  return (
    <CardSelector
      options={options}
      onChange={onChange}
      selectedId={selectedId}
      label={t("billingTypeCardSelector.label")}
    />
  );
};
